// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal.basic.alert-modal.a2p-modal .alert-message {\n  text-align: left;\n  font-size: 14px;\n  max-width: 375px;\n}\n.modal.basic.alert-modal.a2p-modal .external-link {\n  white-space: nowrap;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
